import React, { lazy } from 'react';
interface TreatedImageProps {
  src: string;
  alt: string;
  className?: string;
  /** Tailwind aspect / sizing classes for the wrapper */
  wrapperClassName?: string;
  /** When true, applies a stronger pink rim-light from the top-right */
  rim?: boolean;
}
/**
 * Wraps a bright, clinical photo and renders it in the Be CLINICAL after-dark
 * aesthetic: warm-darkened, low-light, with a near-black wash and a restrained
 * pink rim-light. Hairline border at rest, pink neon outline + glow on hover.
 */
export function TreatedImage({
  src,
  alt,
  className = '',
  wrapperClassName = '',
  rim = true
}: TreatedImageProps) {
  return <div className={`group relative overflow-hidden rounded-bc border border-hairline transition-all bc-ease hover:border-bc-pink hover:bc-glow-box-soft ${wrapperClassName}`} data-id="element-172">
      <img src={src} alt={alt} loading="lazy" className={`h-full w-full object-cover transition-transform duration-700 bc-ease group-hover:scale-105 ${className}`} data-id="element-173" />
      {/* Light wash only at the very bottom, so any caption stays legible */}
      <div className="pointer-events-none absolute inset-0" style={{
      background: 'linear-gradient(180deg, transparent 0%, transparent 62%, rgba(7,7,12,0.55) 100%)'
    }} data-id="element-174" />
      {/* Restrained pink rim-light */}
      {rim && <div className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(90% 70% at 80% 6%, rgba(255,31,143,0.14), transparent 55%)'
    }} data-id="element-175" />}
    </div>;
}